import PageWrapper from "@/pages/PageWrapper";
import Portfolio from "@/sections/Portfolio";
import useSEO from "@/lib/useSEO";

export default function PortfolioPage() {
    useSEO({
        title: "Portfolio — Featured Architecture & Interior Projects in Kerala | ate.teen studio",
        description:
            "Featured work from ate.teen studio across Kerala: private villas in Kundara, Pandikkad and Kottarakara, a Classical Dance Studio in Kollam, a chartered accountant's office in Chinnakada, a 12,000 sq.ft ceramics showroom in Perumbavoor and more.",
        path: "/portfolio",
    });
    return (
        <PageWrapper className="pt-24">
            <h1 className="sr-only">
                Featured architecture and interior design projects by ate.teen studio in Kerala
            </h1>
            <Portfolio />
        </PageWrapper>
    );
}
